<template>
  <div>
    <!------------------
            HEADER
    -------------------->
    <div class="bg-white p-2 pt-3 pb-3 d-flex align-items-top" style="padding-bottom:0;">
      <div class="col">
        <div>
          <h4>
            <b-icon class="me-2" icon="compass" @click="AppState.showNav = true"></b-icon>
            Projektdaten
          </h4>
        </div>
      </div>
    </div>
    <b-nav tabs class="pl-4 bg-white inverted">
      <b-nav-item to="/settings/project">
        Projekteigenschaften
      </b-nav-item>
      <b-nav-item to="/settings/general">
        Allgemein
      </b-nav-item>
      <b-nav-item to="/settings/customattributes">
        VE-Attribute
      </b-nav-item>
      <b-nav-item to="/settings/pat">
        PÄT
      </b-nav-item>
      <b-nav-item to="/settings/useradmin" v-if="$root.$user.isPlaner || $root.$user.isAdmin">
        Zugriffsverwaltung
      </b-nav-item>
      <b-nav-item to="/settings/customeradmin" v-if="$root.$user.isCustomerAdmin">
        Kundenverwaltung
      </b-nav-item>
    </b-nav>

    <div class="main-canvas" style="height: calc( 100vh - 105px);overflow:auto;">
      <keep-alive>
        <router-view :key="$route.fullPath"></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
//import AppState from '@/store/App.js';
export default {
  /*
  activated() {
    this.$eventBus.$on('projectSwitched', this.onProjectSwitched);
  },
  deactivated() {
    this.$eventBus.$off('projectSwitched', this.onProjectSwitched);
  },
  data() {
    return {
      AppState
    };
  },
  methods: {
    onProjectSwitched() {
      this.$forceUpdate();
    }
  }*/
};
</script>

<style></style>
